<template>
  <div class="home-mobile relative px-[12px] pt-14 flex flex-col min-h-full bg-[#F7F8FC] scrollbar-hide"
    :class="{ 'pt-3': isMiniapp }"
    :style="{ paddingBottom: andrioInfo.platform === 'IOS' ? (tabBarHeight + 15) + 'px' : '25px' }">

    <!-- <div class="home-mobile bg-[#F9F6F6] px-[20px] sticky top-0 z-10 flex justify-between items-center" 
          :style="{ 
              paddingTop: barHeight + 'px', /* 状态栏安全距离 */
              zIndex: 999 
          }"
      >
    
      </div> -->
      <!-- <div class="flex h-[38px] w-full items-center justify-between ">
        <img :src="mobileTitle" alt="一点PPT" class="w-[80px] object-cover" />
        <div class="flex items-center gap-[8px]">
          <button type="button" class="relative h-[34px] w-[34px] border-none bg-transparent p-0" @click="goNotification">
            <img :src="noticeEntryIcon" alt="消息" class="w-[34px] h-[34px]" />
            <span v-if="notificationToken && hasUnread" class="absolute right-[2px] top-[2px] h-[6px] w-[6px] rounded-full border border-white bg-[#FF4D4D]"></span>
          </button>
        </div>
      </div> -->

      <div class="flex items-center justify-between mt-2">
        <el-image class="h-[56px] w-[192px] pl-[3px]" :src="Title" alt="一点ppt-标题" />
        <img :src="home_right_icon" alt="" class="h-[82px] max-w-[132px] cursor-pointer">
      </div>



    <div class="yidian-home-content mt-2 bg-[#ffffff] px-[12px] py-[16px] rounded-[16px]">
      <!-- 主输入框 -->
      <div class="main-input-wrapper">
        <!-- 渐变边框容器 -->
        <div class="gradient-border">
          <div class="input-content">
            <!-- 显示上传的文件信息（原顶部位置已移除） -->

            <!-- 主输入框 -->
            <textarea
              v-model="outlineParams.inputText"
              placeholder=""
              class="main-input scrollbar-style"
              :rows="2"
              :maxlength="INPUT_TEXT_MAX_LEN"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
            ></textarea>
            <div v-if="showShinyPlaceholder" class="shiny-placeholder">
              请输入PPT主题，如：新能源汽车发展
            </div>

            <!-- 修改：将原来的 input-actions 替换为动态内容，保持位置不变 -->
            <div class="input-actions">
              <!-- 有文件时显示文件信息条 -->
              <div v-if="localFileInfo" class="file-info-box max-w-[100%] min-w-0">
                <div class="file-info-content max-w-[100%]">
                  <img :src="file_close" alt="关闭" class="w-[16px] h-[16px] mr-[4px] cursor-pointer ] hover:opacity-80"
                    @click.stop="cleareFiles" />
                  <el-image class="file-icon w-[20px]  flex-shrink-0" :src="getFileIcon(localFileInfo.name)"
                    :fit="'contain'" alt="文件图标" />
                  <div class="flex-1 min-w-0">
                    <p class="mx-[4px] truncate text-[#0E172A] text-[12px] font-medium">
                      {{ truncateText(localFileInfo.name, 15) }}
                    </p>
                  </div>

                  <div class="file-status ml-[4px] flex-shrink-0 flex" v-if="localFileInfo.status !== 'success'">
                    <div class="w-[1px] h-[16px] bg-[#091836] bg-opacity-10 mr-[4px]"></div>
                    <div v-if="localFileInfo.status === 'uploading'" class="flex items-center">
                      <img :src="loading" class="w-[14px] h-[14px] is-loading">
                    </div>
                    <div v-if="localFileInfo.status === 'error'" class="flex items-center">
                      <span class="text-[#CF001B] text-[10px]">上传失败</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 无文件时显示上传按钮 -->
              <button v-else class="upload-btn hover:opacity-80 font-medium" @click="openFileSelector">
                <img :src="upload" alt="一点ppt-上传文档按钮" class="w-[16px] h-[16px]" />
                <span class="pt-[1px]">{{ isFileUploaded() ? '重新上传' : '导入文档' }}</span>
              </button>
              <div v-if="isInputFocused" class="input-char-count">
                {{ inputTextLength }}/{{ INPUT_TEXT_MAX_LEN }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-input-options-row flex items-center">
        <div class="mobile-input-options-scroll-wrap min-w-0 flex-1">
          <div ref="inputOptionsScrollRef" class="mobile-input-options-scroll scrollbar-hide">
            <div class="input-options-inner">
          <div class="option-item option-select-trigger" @click="openOptionDrawer('page')">
            <span class="option-label">
              <span class="option-label-name">{{ pageLabelParts.name }}</span>
              <span v-if="pageLabelParts.value" class="option-label-value">{{ pageLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('language')">
            <span class="option-label">
              <span class="option-label-name">{{ languageLabelParts.name }}</span>
              <span v-if="languageLabelParts.value" class="option-label-value">{{ languageLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('audiences')">
            <span class="option-label">
              <span class="option-label-name">{{ audiencesLabelParts.name }}</span>
              <span v-if="audiencesLabelParts.value" class="option-label-value">{{ audiencesLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('textVolume')">
            <span class="option-label">
              <span class="option-label-name">{{ textVolumeLabelParts.name }}</span>
              <span v-if="textVolumeLabelParts.value" class="option-label-value">{{ textVolumeLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="option-item option-select-trigger" @click="openOptionDrawer('scene')">
            <span class="option-label">
              <span class="option-label-name">{{ sceneLabelParts.name }}</span>
              <span v-if="sceneLabelParts.value" class="option-label-value">{{ sceneLabelParts.value }}</span>
            </span>
            <el-icon class="option-arrow">
              <ArrowDown />
            </el-icon>
          </div>
            </div>
          </div>
        </div>
        <button type="button" class="option-edit-btn" @click="openOptionDrawer('page')">
          <img :src="customize" alt="" class="w-[20px] h-[20px]">
        </button>
      </div>

      <!-- 选项设置抽屉 -->
      <el-drawer 
        v-model="optionDrawerVisible"
        :with-header="false"
        modal-class="mobile-option-drawer"
        body-class="!p-0"
        :size="optionDrawerSize"
        direction="btt"
        @closed="handleOptionDrawerClosed"
      >
        <div class="option-drawer-panel">
          <div class="option-drawer-tabs">
            <button
              v-for="tab in optionTabs"
              :key="tab.key"
              type="button"
              class="option-drawer-tab"
              :class="{ 'is-active': optionDrawerType === tab.key }"
              @click="switchOptionTab(tab.key)"
            >
              <img
                :src="optionDrawerType === tab.key ? tab.activeIcon : tab.icon"
                alt=""
                class="option-drawer-tab-icon"
              />
              <span>{{ tab.label }}</span>
            </button>
          </div>

          <div class="option-drawer-content scrollbar-style scrollbar-hide">
            <div v-if="optionDrawerType === 'scene'" class="option-grid">
              <button
                v-for="item in sceneOpts"
                :key="item.value"
                type="button"
                class="option-grid-item"
                :class="{ 'is-selected': isDraftOptionSelected(item.value) }"
                @click="selectDraftOption(item.value)"
              >
                {{ item.label }}
              </button>
              <button
                type="button"
                class="option-grid-item option-grid-item--custom"
                :class="{ 'is-selected': isDraftCustomSceneSelected }"
                @click="openCustomSceneModal"
              >
                <img
                  :src="isDraftCustomSceneSelected ? customize_sel : customize"
                  alt=""
                  class="option-grid-custom-icon"
                />
                <span class="truncate">{{ customSceneButtonText }}</span>
              </button>
            </div>
            <div v-else class="option-grid">
              <button
                v-for="item in currentDrawerOptions"
                :key="item.value"
                type="button"
                class="option-grid-item"
                :class="{ 'is-selected': isDraftOptionSelected(item.value) }"
                @click="selectDraftOption(item.value)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>

          <div class="option-drawer-footer">
            <button type="button" class="option-drawer-btn option-drawer-btn--ghost" @click="resetOptionDrawer">
              恢复默认
            </button>
            <button type="button" class="option-drawer-btn option-drawer-btn--primary" @click="confirmOptionDrawer">
              确认设置
            </button>
          </div>
        </div>
      </el-drawer>
      <!-- :class="canSubmit ? 'btn-enabled' : 'btn-disabled'" -->
      <div
        class="yidian-mobile-btn btn-enabled flex items-center justify-center w-full mx-auto py-[11px] mt-[16px] text-[#ffffff] text-[15px] rounded-[110px] cursor-pointer"
       @click="handleCreate">
        <el-image class="w-[22px] h-[22px] mr-2" :src="xin" alt="一点ppt-标题" />
        立即生成
      </div>
      <!-- 微信小程序审核：AI 生成内容标识 -->
      <div v-if="isMiniapp" class="miniapp-ai-disclaimer">
        内容由 AI 生成，仅供参考
      </div>
  
      <!-- 热点模块：两行各自横向滚动 + 默认走马灯 -->
      <div ref="hotTopicsContainerRef" class="mobile-hot-topics mt-[12px]">
        <div
          v-for="(row, rowIndex) in hotModelRows"
          :key="rowIndex"
          :ref="(el) => setHotRowRef(el, rowIndex)"
          class="mobile-hot-topics-row scrollbar-hide"
          @touchstart.passive="pauseHotMarquee(rowIndex)"
          @touchend="resumeHotMarquee()"
          @touchcancel="resumeHotMarquee()"
          @mousedown="pauseHotMarquee(rowIndex)"
          @mouseup="resumeHotMarquee()"
          @mouseleave="resumeHotMarquee()"
          @scroll="handleHotRowScroll"
        >
          <div
            class="hot-topics-inner"
            :class="{
              'is-marquee-paused': hotMarqueeUserInteracting,
              'is-marquee-manual': hotMarqueeManualMode,
            }"
            :style="{ animationDuration: rowIndex === 0 ? '26s' : '32s' }"
          >
            <template v-for="copy in 2" :key="`copy-${rowIndex}-${copy}`">
              <div
                v-for="item in row"
                :key="`${copy}-${item.id}`"
                class="hot-topic-item"
                @click="changeHot(item)"
              >
                <el-image class="w-[14px] h-[14px] flex-shrink-0" :src="hot" alt="" />
                <span class="truncate text-brands/[0.6]">{{ item.name }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>

    </div>


    <div ref="memberBannerRef" class="member-banner mt-[10px]" v-if="activityBannerList.length > 0">
      <swiper
        :modules="bannerModules"
        :slides-per-view="1"
        :loop="activityBannerList.length > 1"
        :space-between="10"
        :autoplay="{ delay: 5000, disableOnInteraction: false }"
        class="swiper-member"
      >
        <swiper-slide v-for="(item, index) in activityBannerList" :key="item.id ?? index">
          <el-image class="member-banner-image" :src="item.content" fit="cover" @click="goAndiroMember(item)" />
        </swiper-slide>
      </swiper>
    </div>

    <section class="mt-[10px] bg-[#ffffff] px-[12px] py-[16px] rounded-[16px] flex  flex-col">
        <div class="shrink-0 flex items-center justify-between">
          <div class="flex items-center gap-[4px]">
            <img :src="sectionTitleIcon" alt="" class="h-[16px] w-[16px] ml-[6px]"  />
            <h2 class="text-[15px] font-semibold leading-[24px] text-[#1d1f26]">模板风格预览</h2>
          </div>

          <button
            type="button"
            class="flex items-center gap-[4px] border-none bg-transparent p-0 text-[14px] leading-[16px] "
            @click="handleAllTemplates"
          >
            <span class="whitespace-nowrap font-medium text-[14px] text-brands/[0.5]">全部模板</span>
            <img :src="chevronIcon" alt="" class="h-[12px] w-[12px]" />
          </button>
        </div>

        <div
          ref="templateScrollContainerRef"
          class="mt-[10px] min-h-0 flex-1 overflow-y-auto  pr-[2px] scrollbar-hide"
          @scroll="handleTemplateScroll"
        >
          <div v-if="templatesLoading" class="grid grid-cols-2 gap-x-[12px] gap-y-[8px]">
            <div
              v-for="item in 8"
              :key="item"
              class="text-left"
            >
              <div class="aspect-video overflow-hidden rounded-[7.2px] border border-[rgba(2,10,57,0.13)] bg-[#f6f7f8]" />
              <div class="mt-[8px] h-[12px] w-[72px] rounded-full bg-[#eff1f5]" />
            </div>
          </div>

          <template v-else-if="templates.length">
            <div class="grid grid-cols-2 gap-x-[12px] gap-y-[12px]">
              <button
                v-for="template in templates.slice(0, 4)"
                :key="template.id"
                type="button"
                class="template-card-button block w-full text-left"
                @click="handleTemplateClick(template)"
              >
                <div class="relative aspect-video overflow-hidden rounded-[8px] border border-solid border-[rgba(2,10,57,0.13)] bg-white" style="--ppt-thumbnail-radius: 6.2px">
                  <img
                    v-if="shouldShowTemplateHomepage(template)"
                    :src="template.homepage"
                    :alt="template.title"
                    class="h-full w-full object-cover"
                    @error="handleTemplateHomepageError(template)"
                  />
                  <div
                    v-else
                    class="relative flex h-full w-full items-center justify-center bg-[#f6f7f8]"
                  >
                    <img :src="placeholderBg" alt="" class="h-full w-full object-cover" />
                    <img :src="placeholderAnim" alt="加载中" class="absolute h-[28px] w-[28px]" />
                  </div>
                  <div v-if="isVipTemplate(template)" class="absolute right-[6px] top-[6px] z-30 flex h-[22px] w-[82px] items-center rounded-[42px] bg-[linear-gradient(180deg,#3E2F1C_0%,#25221D_100%)] pl-[9px] pr-[8px]">
                    <img :src="vipIcon" alt="" class="h-[14px] w-[14px] shrink-0" />
                    <span class="ml-[4px] whitespace-nowrap text-center text-[12px] font-normal leading-[21px] text-[#FFE279]">会员专享</span>
                  </div>
                </div>
                <p class="mt-[8px] truncate text-[12px] leading-[12px] text-[rgba(1,3,10,0.89)]">{{ template.title }}</p>
              </button>
            </div>
          </template>

          <div v-else class="flex h-full min-h-[180px] items-center justify-center text-[12px] leading-[18px] text-[rgba(6,10,38,0.48)]">
            暂无相关模板
          </div>
        </div>
      </section>


    <!-- 自定义场景弹窗 -->
    <div v-if="customSceneModalVisible" class="custom-scene-overlay" @click.self="closeCustomSceneModal">
      <div class="custom-scene-modal" @click.stop>
        <h3 class="custom-scene-title">自定义场景</h3>
        <div class="custom-scene-input-wrap">
          <input
            v-model="customSceneInput"
            type="text"
            maxlength="15"
            class="custom-scene-input"
            placeholder="请输入自定义场景"
            @keyup.enter="confirmCustomScene"
          />
          <span class="custom-scene-count">{{ customSceneInput.length }}/15</span>
        </div>
        <div class="custom-scene-actions">
          <button type="button" class="custom-scene-btn custom-scene-btn--ghost" @click="closeCustomSceneModal">
            取消
          </button>
          <button type="button" class="custom-scene-btn custom-scene-btn--primary" @click="confirmCustomScene">
            确定
          </button>
        </div>
      </div>
    </div>

    <!-- 隐藏的文件输入 -->
    <input type="file" ref="fileInput" style="display: none" @change="onFileChange" accept=".docx,.txt,.pdf,.doc" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, onActivated, onDeactivated, watch } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useFileStore } from '@/store/file'
import { useSlidesStore } from '@/store'
import * as TemplateApi from '@/api/template.ts'
import { getDataByType, isVipTemplate } from '@/utils/common'
import { showAndiroTab, getIOSInfo, reportEvent, isGrantedPermission, requestPermission, syncTabBarHeightIfNeeded, isMiniAppWebview, ensureNativeLogin, requestMiniAppSwitchTab, requestMiniAppOpenWebview, getToken } from '@/utils/auth.ts'
import { persistOutlineDraftIfPossible, saveOutlineDraftToStorage, encodeOutlineDraftForTransport, writeOutlineDraftToCookie } from '@/utils/createDraftCache'
import { isPointInElement, toGesturePoint, registerCustomGestureHandler, unregisterCustomGestureHandler } from '@/utils/customGesture'
import { useCreateDraftCache } from '@/hooks/useCreateDraftCache'
import { ElMessage } from 'element-plus'
import { ArrowDown, EditPen, Loading } from '@element-plus/icons-vue'
import file_close from '@/assets/images/home/file_close.png';
import loading from '@/assets/images/home/loading.png';
import upload from '@/assets/images/home/input_upload.png';
import hot from '@/assets/images/mobile/hot.png'
import xin from '@/assets/images/home/xin2.png'
import Title from '@/assets/images/mobile/home_title.png'
import home_right_icon from '@/assets/images/mobile/home_right_icon.png'
import noticeEntryIcon from '@/assets/images/home/mobile-header-notice-entry.png'
import word from '@/assets/images/PPT/file_word.png'
import text from '@/assets/images/PPT/file_text.png'
import pdf from '@/assets/images/PPT/file_pdf.png'
import sectionTitleIcon from '@/assets/images/pptHome/icons/section-title.png'
import chevronIcon from '@/assets/images/pptHome/icons/chevron.png'
import placeholderBg from '@/assets/images/home/bg_loading.png'
import placeholderAnim from '@/assets/images/home/loading_star.webp'
import vipIcon from '@/assets/images/member/icon_vip.png'
import { languageOptions } from '@/utils/language'
import { textOpts, audiencesOpts, sceneOpts } from '@/utils/pptInputOptions'
import customize from '@/assets/images/home/customize.png'
import customize_sel from '@/assets/images/home/customize_sel.png'
import page from '@/assets/images/pptHome/icons/page.svg'
import page_active from '@/assets/images/pptHome/icons/page_active.svg'
import language from '@/assets/images/pptHome/icons/language.svg'
import language_active from '@/assets/images/pptHome/icons/language_active.svg'
import audiences from '@/assets/images/pptHome/icons/audiences.svg'
import audiences_active from '@/assets/images/pptHome/icons/audiences_active.svg'
import scene from '@/assets/images/pptHome/icons/scene.svg'
import scene_active from '@/assets/images/pptHome/icons/scene_active.svg'
import textVolume from '@/assets/images/pptHome/icons/textVolume.svg'
import textVolume_active from '@/assets/images/pptHome/icons/textVolume_active.svg'
import mobileTitle from '@/assets/images/mobile/mobile_title.png'
import * as UserApi from '@/api/user.ts'
import { getUnreadCount } from '@/api/notification.ts'
import { ACTIVITY_LOCATION } from '@/utils/activityLocation'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

const router = useRouter()
const appStore = useAppStore()
const userStore = useUserStore()
const fileStore = useFileStore()
const slidesStore = useSlidesStore()
const { outlineParams, tabBarHeight } = storeToRefs(appStore)
const isMiniapp = isMiniAppWebview()
const { uploadedFile } = storeToRefs(fileStore)

const andrioInfo = computed(() => appStore.getAndrio)

// 未读消息红点
const notificationToken = ref(getToken())
const hasUnread = ref(false)
const NOTIFICATION_UNREAD_REFRESH_EVENT = 'notification-unread-refresh'

const syncNotificationToken = () => {
  notificationToken.value = getToken()
  if (!notificationToken.value) {
    hasUnread.value = false
  }
  return notificationToken.value
}

const fetchUnreadCount = async () => {
  if (!syncNotificationToken()) return
  return
  try {
    const res = await getUnreadCount({ params: {} })
    if (res.code === 'SUCCESS' && res.data) {
      hasUnread.value = res.data.unreadCount > 0
    }
  } catch {}
}

const goNotification = () => {
  router.push('/m/notification')
}

const bannerModules = [Autoplay]

const activityBannerList = ref([])

const getHomeBannerList = async () => {
  try {
    const res = await UserApi.getBannerListByLocation({
      params: {
        location: ACTIVITY_LOCATION.HOME
      }
    })
    if (res.code === 'SUCCESS') {
      activityBannerList.value = Array.isArray(res.data) ? res.data : []
    }
  } catch {
    activityBannerList.value = []
  }
}

// bannerList: [
//   {
//       content: activePositive,
//       id: 1,
//       linkUrl: 'https://alidocs.dingtalk.com/notable/share/form/v01eYVOL5oz0p5Pzlpz_H9EkGJ0_yvVzwb0?source=link',
//       title: '好评送会员',
//     },
//     {
//       content: activeBanner,
//       id: 2,
//       linkUrl: 'activities-sdk',
//       title: '扫码进福利群',
//     },
//     {
//       content: activeBanner,
//       id: 3,
//       linkUrl: '/m/invite',
//       title: '邀请好友赢好礼',
//     },
//     {
//       content: activePositive,
//       id: 4,
//       linkUrl: '/m/my-coupon',
//       title: '领劵中心',
//     },
//   ],
// const languageOptions = [
//   { value: 'zh', label: '语言：中文' },
//   { value: 'en', label: '语言：英文' },
// ]

// 文件上传相关（按需加载，避免阻塞首屏）
const fileInput = ref(null)
let uploadRuntime = null
// 本地文件信息用于 UI 展示
const localFileInfo = ref(null)


const TEMPLATE_PAGE_SIZE = 10
const TEMPLATE_SCROLL_THRESHOLD = 80

const inputOptionsScrollRef = ref(null)
const hotTopicsContainerRef = ref(null)
const memberBannerRef = ref(null)
const hotRowRefs = ref([])
const templateScrollContainerRef = ref(null)
const templates = ref([])
const templatesLoading = ref(false)
const templatesLoadingMore = ref(false)
const templatesPageNo = ref(1)
const templatesTotal = ref(0)
const templatesHasMore = computed(() => templates.value.length < templatesTotal.value)

const normalizeTemplateItem = (item) => ({
  ...item,
  title: item.name,
  homepage: getDataByType(item.coverList, 'homePage'),
  homepageLoadFailed: false
})

const ensureUploadRuntime = async () => {
  if (uploadRuntime) return uploadRuntime
  const { useFileUpload } = await import('@/hooks/useFileUpload')
  uploadRuntime = useFileUpload({
    fileSizeLimit: 10 * 1024 * 1024, // 10MB
    textLengthLimit: 20000, // 2万字
    allowedTypes: ['.doc', '.docx', '.txt', '.pdf']
  })
  return uploadRuntime
}

const isFileUploaded = () => !!uploadedFile.value

const INPUT_TEXT_MAX_LEN = 10000
const isInputFocused = ref(false)

const inputTextLength = computed(() => (outlineParams.value.inputText || '').length)

const handleInputFocus = () => {
  isInputFocused.value = true
}

const handleInputBlur = () => {
  isInputFocused.value = false
}

const showShinyPlaceholder = computed(() => {
  return !outlineParams.value.inputText?.trim() && !isInputFocused.value
})

// 是否可以提交（有输入内容或已上传文件）
const canSubmit = computed(() => {
  const hasText = outlineParams.value.inputText && outlineParams.value.inputText.trim()
  const hasSuccessFile = localFileInfo.value && localFileInfo.value.status === 'success'
  return hasText || hasSuccessFile
})

// 获取文件图标
const getFileIcon = (filename) => {
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  if (ext === 'docx' || ext === 'doc') return word
  if (ext === 'txt') return text
  return pdf
}

const truncateText = (str, maxLength) => {
  if (!str) return ''
  if (str.length <= maxLength) return str
  return str.substring(0, maxLength) + '...'
}

// 页数选项
const pageOptions = [
  { value: '5-10页', label: '页数: 5-10页' },
  { value: '10-15页', label: '页数: 10-15页' },
  { value: '15-20页', label: '页数: 15-20页' },
  { value: '20-25页', label: '页数: 20-25页' },
  { value: '25-30页', label: '页数: 25-30页' },
  { value: '30-35页', label: '页数: 30-35页' },
  { value: '20页以内', label: '页数: 智能页数' },
];

const optionDrawerItemsMap = {
  page: pageOptions,
  language: languageOptions,
  audiences: audiencesOpts,
  textVolume: textOpts,
  scene: sceneOpts
}

const optionTabs = [
  { key: 'language', label: '语言', icon: language, activeIcon: language_active },
  { key: 'page', label: '页数', icon: page, activeIcon: page_active },
  { key: 'audiences', label: '受众', icon: audiences, activeIcon: audiences_active },
  { key: 'scene', label: '场景', icon: scene, activeIcon: scene_active },
  { key: 'textVolume', label: '文本', icon: textVolume, activeIcon: textVolume_active }
]

const defaultOutlineOptions = {
  pageCount: '20页以内',
  language: 'zh',
  audiences: '',
  textVolume: '详细',
  scene: ''
}

useCreateDraftCache({
  outlineParams,
  uploadedFile,
  localFileInfo,
  defaultOutlineOptions,
  fileStore,
})

const CUSTOM_SCENE_MAX_LENGTH = 15

// 页数/语言/受众/文本量/场景选择抽屉
const optionDrawerVisible = ref(false)
const optionDrawerType = ref('language')
const customSceneModalVisible = ref(false)
const customSceneInput = ref('')
const draftParams = ref({ ...defaultOutlineOptions })

const optionDrawerSize = computed(() => {
  const isAndroid = andrioInfo.value.platform === 'ANDROID'
  return isAndroid ? '45%' : '48%'
})

const pageDrawerOptions = pageOptions.map((item) => ({
  value: item.value,
  label: item.label.replace('页数: ', '')
}))

const currentDrawerOptions = computed(() => {
  const type = optionDrawerType.value
  if (type === 'page') return pageDrawerOptions
  return optionDrawerItemsMap[type] || []
})

const isDraftCustomSceneSelected = computed(() => {
  const scene = draftParams.value.scene
  return Boolean(scene) && !sceneOpts.some((item) => item.value === scene)
})

const customSceneButtonText = computed(() => {
  if (isDraftCustomSceneSelected.value) {
    return draftParams.value.scene
  }
  return '自定义'
})

const pageLabelParts = computed(() => {
  const item = pageOptions.find((o) => o.value === outlineParams.value.pageCount)
  return {
    name: '页数',
    value: item ? item.label.replace('页数: ', '') : ''
  }
})

const languageLabelParts = computed(() => {
  const item = languageOptions.find((o) => o.value === outlineParams.value.language)
  return {
    name: '语言',
    value: item?.label || ''
  }
})

const audiencesLabelParts = computed(() => ({
  name: '受众',
  value: outlineParams.value.audiences || ''
}))

const textVolumeLabelParts = computed(() => ({
  name: '文本量',
  value: outlineParams.value.textVolume || ''
}))

const sceneLabelParts = computed(() => {
  const scene = outlineParams.value.scene
  if (!scene) return { name: '场景', value: '' }
  const matched = sceneOpts.find((o) => o.value === scene)
  return {
    name: '场景',
    value: matched ? matched.label : scene
  }
})
const syncDraftFromOutline = () => {
  draftParams.value = {
    pageCount: outlineParams.value.pageCount || defaultOutlineOptions.pageCount,
    language: outlineParams.value.language || defaultOutlineOptions.language,
    audiences: outlineParams.value.audiences || defaultOutlineOptions.audiences,
    textVolume: outlineParams.value.textVolume || defaultOutlineOptions.textVolume,
    scene: outlineParams.value.scene || defaultOutlineOptions.scene
  }
}

const isDraftOptionSelected = (value) => {
  const type = optionDrawerType.value
  if (type === 'page') return draftParams.value.pageCount === value
  if (type === 'language') return draftParams.value.language === value
  if (type === 'audiences') return draftParams.value.audiences === value
  if (type === 'textVolume') return draftParams.value.textVolume === value
  return draftParams.value.scene === value
}

const openOptionDrawer = (type) => {
  syncDraftFromOutline()
  optionDrawerType.value = type
  optionDrawerVisible.value = true
  showAndiroTab(false)
}

const switchOptionTab = (type) => {
  optionDrawerType.value = type
}

const closeOptionDrawer = () => {
  optionDrawerVisible.value = false
  showAndiroTab(true)
}

const handleOptionDrawerClosed = () => {
  customSceneModalVisible.value = false
  customSceneInput.value = ''
  showAndiroTab(true)
}

const selectDraftOption = (value) => {
  const type = optionDrawerType.value
  if (type === 'page') {
    draftParams.value.pageCount = value
  } else if (type === 'language') {
    draftParams.value.language = value
  } else if (type === 'audiences') {
    draftParams.value.audiences = value
  } else if (type === 'textVolume') {
    draftParams.value.textVolume = value
  } else if (type === 'scene') {
    draftParams.value.scene = value
  }
}

const applyDraftToOutline = () => {
  outlineParams.value.pageCount = draftParams.value.pageCount
  outlineParams.value.language = draftParams.value.language
  outlineParams.value.audiences = draftParams.value.audiences
  outlineParams.value.textVolume = draftParams.value.textVolume
  outlineParams.value.scene = draftParams.value.scene
}

const confirmOptionDrawer = () => {
  applyDraftToOutline()
  closeOptionDrawer()
}

const resetOptionDrawer = () => {
  draftParams.value = { ...defaultOutlineOptions }
}

const openCustomSceneModal = () => {
  customSceneInput.value = isDraftCustomSceneSelected.value ? draftParams.value.scene : ''
  customSceneModalVisible.value = true
}

const closeCustomSceneModal = () => {
  customSceneModalVisible.value = false
  customSceneInput.value = ''
}

const confirmCustomScene = () => {
  const trimmed = customSceneInput.value.trim()
  if (!trimmed) {
    ElMessage.error({
      message: '请输入自定义场景',
      offset: 60
    })
    return
  }
  draftParams.value.scene = trimmed.slice(0, CUSTOM_SCENE_MAX_LENGTH)
  closeCustomSceneModal()
}

const hotModels = ref([
  { id: 1, name: '汽车市场分析报告' },
  { id: 2, name: '如何提升电商平台转化率计划' },
  { id: 3, name: '市场部年度目标制定与执行' },
  { id: 4, name: '春季北京周边3日游攻略' },
  { id: 5, name: '分析养生服务行业发展趋势' },
  { id: 6, name: '校园文化节活动策划方案与预算执行细则' },
  { id: 7, name: '大学生创新创业项目汇报' },
])

const hotModelRows = computed(() => {
  const list = hotModels.value
  const mid = Math.ceil(list.length / 2)
  return [list.slice(0, mid), list.slice(mid)]
})

const hotMarqueeUserInteracting = ref(false)
const hotMarqueeManualMode = ref(false)
let hotMarqueeResumeTimer = null
let hotRowScrollEndTimer = null
let hotRowScrollAdjusting = false

const HOT_MARQUEE_RESUME_DELAY = 2500

const setHotRowRef = (el, index) => {
  if (el) {
    hotRowRefs.value[index] = el
  }
}

const getHotRowInner = (rowEl) => rowEl?.querySelector('.hot-topics-inner')

const getHotRowHalfWidth = (rowEl) => {
  const inner = getHotRowInner(rowEl)
  if (!inner) return 0
  return inner.scrollWidth / 2
}

/** 暂停走马灯时，把 CSS transform 偏移同步到 scrollLeft，便于手动无限滚动 */
const syncHotMarqueeToScroll = (rowIndex) => {
  const row = hotRowRefs.value[rowIndex]
  const inner = getHotRowInner(row)
  if (!row || !inner) return

  const transform = window.getComputedStyle(inner).transform
  let translateX = 0
  if (transform && transform !== 'none') {
    translateX = new DOMMatrix(transform).m41
  }

  hotMarqueeManualMode.value = true
  row.scrollLeft = Math.max(0, -translateX)
}

const resetHotRowForMarquee = (rowIndex) => {
  const row = hotRowRefs.value[rowIndex]
  if (!row) return

  row.scrollLeft = 0
}

const restartHotMarqueeAnimations = () => {
  hotMarqueeManualMode.value = false
  hotMarqueeUserInteracting.value = false
  hotRowRefs.value.forEach((row) => {
    const inner = getHotRowInner(row)
    if (inner) {
      void inner.offsetWidth
    }
  })
}

const scheduleHotMarqueeResume = (delay = HOT_MARQUEE_RESUME_DELAY) => {
  if (hotMarqueeResumeTimer) clearTimeout(hotMarqueeResumeTimer)
  hotMarqueeResumeTimer = setTimeout(() => {
    hotRowRefs.value.forEach((_, index) => {
      resetHotRowForMarquee(index)
    })
    restartHotMarqueeAnimations()
    hotMarqueeResumeTimer = null
  }, delay)
}

const handleHotRowScroll = (event) => {
  if (hotRowScrollAdjusting || !hotMarqueeUserInteracting.value) return

  const row = event.target
  const halfWidth = getHotRowHalfWidth(row)
  if (halfWidth <= 0) return

  if (row.scrollLeft >= halfWidth) {
    hotRowScrollAdjusting = true
    while (row.scrollLeft >= halfWidth) {
      row.scrollLeft -= halfWidth
    }
    hotRowScrollAdjusting = false
  }

  if (hotRowScrollEndTimer) clearTimeout(hotRowScrollEndTimer)
  hotRowScrollEndTimer = setTimeout(() => {
    hotRowScrollEndTimer = null
    scheduleHotMarqueeResume()
  }, 180)
}

const pauseHotMarquee = (rowIndex) => {
  if (!hotMarqueeUserInteracting.value) {
    hotRowRefs.value.forEach((_, index) => {
      syncHotMarqueeToScroll(index)
    })
  }
  hotMarqueeUserInteracting.value = true
  if (hotMarqueeResumeTimer) {
    clearTimeout(hotMarqueeResumeTimer)
    hotMarqueeResumeTimer = null
  }
  if (hotRowScrollEndTimer) {
    clearTimeout(hotRowScrollEndTimer)
    hotRowScrollEndTimer = null
  }
}

const resumeHotMarquee = (delay = HOT_MARQUEE_RESUME_DELAY) => {
  scheduleHotMarqueeResume(delay)
}

const clearHotMarqueeTimer = () => {
  if (hotMarqueeResumeTimer) {
    clearTimeout(hotMarqueeResumeTimer)
    hotMarqueeResumeTimer = null
  }
  if (hotRowScrollEndTimer) {
    clearTimeout(hotRowScrollEndTimer)
    hotRowScrollEndTimer = null
  }
}

const init = () => {
  outlineParams.value.pageCount = outlineParams.value.pageCount || defaultOutlineOptions.pageCount
  outlineParams.value.language = outlineParams.value.language || defaultOutlineOptions.language
  outlineParams.value.audiences = outlineParams.value.audiences || defaultOutlineOptions.audiences
  outlineParams.value.textVolume = outlineParams.value.textVolume || defaultOutlineOptions.textVolume
  outlineParams.value.scene = outlineParams.value.scene || defaultOutlineOptions.scene

  if(window.prompt){
    const data = getIOSInfo();
    appStore.setAndrioInfo(data);
  }
  getHomeBannerList()
  setTimeout(() => {
    window.openSdkModal?.(ACTIVITY_LOCATION.HOME)
  }, /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 800 : 300)
}

const handleCustomGesture = (downX, downY) => {
  if (router.currentRoute.value.path !== '/m/home') {
    return false
  }
  const { x, y } = toGesturePoint(downX, downY)
  return (
    isPointInElement(x, y, inputOptionsScrollRef.value) ||
    isPointInElement(x, y, hotTopicsContainerRef.value) ||
    isPointInElement(x, y, memberBannerRef.value)
  )
}

const setupCustomGesture = () => registerCustomGestureHandler(handleCustomGesture)
const teardownCustomGesture = () => unregisterCustomGestureHandler(handleCustomGesture)

const changeHot = (item) => {
  reportEvent('app_clicks', {
    ck_module: '首页_快捷按钮',
  })
  outlineParams.value.inputText = item.name
  handleCreate()
}

// 文件上传相关方法
const openFileSelector = () => {
  reportEvent('app_clicks', {
    ck_module: '首页_上传文档',
  })
  if (!ensureNativeLogin()) return
  if (fileInput.value) {
    fileInput.value.click()
  }
}

const onFileChange = async (event) => {
  const target = event.target
  const file = target.files?.[0]

  if (!file) return

  // 清除之前的文件
  cleareFiles()

  // 设置本地状态为上传中
  localFileInfo.value = {
    name: file.name,
    status: 'uploading'
  }

  const runtime = await ensureUploadRuntime()
  try {
    const success = await runtime.handleFileUpload(file)
    if (success) {
      localFileInfo.value.status = 'success'
      if (uploadedFile.value) {
        outlineParams.value.fujian = uploadedFile.value.fujian
      }
    } else {
      localFileInfo.value.status = 'error'
      fileStore.clearFile()
      ElMessage.error({
        message: '文件上传失败，请检查文件格式和大小',
        offset: 60,
      })
    }
  } catch (error) {
    localFileInfo.value.status = 'error'
    fileStore.clearFile()
    ElMessage.error({
      message: '文件上传失败，请重试',
      offset: 60,
    })
  } finally {
    if (fileInput.value) {
      fileInput.value.value = ''
    }
  }
}

const cleareFiles = () => {
  fileStore.clearFile()
  if (uploadRuntime) {
    uploadRuntime.removeFile()
  }
  localFileInfo.value = null
  if (fileInput.value) {
    fileInput.value.value = ''
  }
}

const checkFileType = (filename) => {
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  return ext
}

const handleAllTemplates = () => {
  reportEvent('app_clicks', { ck_module: 'PPT制作_首页_点击全部模版' })
  if (isMiniAppWebview()) {
    requestMiniAppSwitchTab('template')
    return
  }
  if (window.JsAndroid) {
    window.location.href = `ydppt://index?tab=template`
    return
  }
  if (window.prompt) {
    window.location.href = `ydppt://index?tab=template`
    return
  }
  router.push('/m/Template')
}

const goAndiroMember = (item) => {
  reportEvent('app_clicks', {
    ck_module: item.title,
  })

  setTimeout(() => {
    const linkUrl = item.linkUrl || ''

    // 小程序：对齐原生 ydppt://webview，打开全屏 web-view 页
    if (isMiniAppWebview()) {
      if (linkUrl.startsWith('web:')) {
        router.push(linkUrl.replace('web:', ''))
        return
      }
      if (linkUrl.startsWith('ydppt:')) {
        // 原生协议在小程序内不可用，忽略
        return
      }

      // 会员页跳转小程序 tab 会员页
      if (/\/m\/member/i.test(linkUrl)) {
        requestMiniAppSwitchTab('member')
        return
      }

      // 外链（含 activity:https://...）：先开业务域名中转页，再尝试跳转/复制
      const externalUrl = linkUrl.startsWith('activity:')
        ? linkUrl.replace('activity:', '')
        : linkUrl
      if (/^https?:\/\//i.test(externalUrl)) {
        const title = item.title || '活动详情'
        requestMiniAppOpenWebview({
          path: `/m/open-link?target=${encodeURIComponent(externalUrl)}&title=${encodeURIComponent(title)}`,
          title,
        })
        return
      }

      // 业务 H5 相对路径：交给小程序 pages/webview 拼域名 + token
      const path = linkUrl.startsWith('/') ? linkUrl : `/${linkUrl}`
      requestMiniAppOpenWebview({
        path,
        title: item.title || '详情',
      })
      return
    }

    if (linkUrl.startsWith('ydppt:')) {
      if (window.JsAndroid) {
        window.location.href = linkUrl
      } else if (window.prompt) {
        const isLogin = window.prompt('ydppt://isLogin')
        const isLoggedIn = isLogin !== null && isLogin !== undefined && isLogin !== 'false'
        if (isLoggedIn) {
          window.location.href = linkUrl
        } else {
          window.prompt('ydppt://login')
        }
      }
    } else if (linkUrl.startsWith('web:')) {
      const url = linkUrl.replace('web:', '')
      router.push(url)
    } else if (linkUrl.startsWith('activity:')) {
      const url = linkUrl.replace('activity:', '')
      window.location.href = 'ydppt://webview?url=' + url
    } else if (linkUrl.startsWith('webview:')) {
      //给不使用title的链接使用
      const url = linkUrl.replace('webview:', '')
      window.location.href = 'ydppt://webview?url=' + url + '&title='
    } else if(/^https?:\/\//.test(linkUrl)){
      console.log('linkUrl',linkUrl);
      
      if(window.JsAndroid || window.prompt){
        // const isMiniappHome = linkUrl.startsWith('https://testweb.gongwenbao-ai.com/miniapp/home')
        const webviewTitle = (item.title || '') 
        window.location.href = 'ydppt://webview?url=' + encodeURIComponent(linkUrl) + '&title=' + encodeURIComponent(webviewTitle)
      } else {
        window.location.href = linkUrl
      }
    } else if(linkUrl.startsWith('/')){
      if(window.JsAndroid || window.prompt){
        const separator = linkUrl.includes('?') ? '&' : '?'
        window.location.href = 'ydppt://webview?url=' + location.origin  + linkUrl + separator + 'fromType=home' + '&title=' + encodeURIComponent(item.title || '');
      } else {
        push(linkUrl)
      }
    } else {
      // push(url);
      window.location.href = 'ydppt://webview?url=' + location.origin  + linkUrl+ '?fromType=home' + '&title=';
    }
  }, 150)
}

const handleTemplateScroll = () => {
  const container = templateScrollContainerRef.value
  if (!container || templatesLoading.value || templatesLoadingMore.value || !templatesHasMore.value) return

  const { scrollTop, scrollHeight, clientHeight } = container
  if (scrollHeight - scrollTop - clientHeight < TEMPLATE_SCROLL_THRESHOLD) {
    fetchTemplates()
  }
}

const handleTemplateClick = (template) => {
  // persistMobileCreateDraft()
  // if (!ensureNativeLogin()) return
  slidesStore.setYdTemplates(template)
  if (isMiniAppWebview()) {
    requestMiniAppOpenWebview({
      path: `/m/Template/detail?id=${template.id}&from=home`,
      title: '模板详情',
    })
    return
  }
  router.push({
    path: '/m/Template/detail',
    query: {
      id: template.id,
      from: 'home'
    }
  })
}

const shouldShowTemplateHomepage = (template) => Boolean(template?.homepage && !template?.homepageLoadFailed)

const handleTemplateHomepageError = (template) => {
  if (template) {
    template.homepageLoadFailed = true
  }
}

const fetchTemplates = async (reset = false) => {
  if (reset) {
    if (templatesLoading.value || templatesLoadingMore.value) return
    templatesLoading.value = true
    templatesPageNo.value = 1
  } else {
    if (templatesLoading.value || templatesLoadingMore.value || !templatesHasMore.value) return
    templatesLoadingMore.value = true
    templatesPageNo.value += 1
  }

  try {
    const params = {
      pageNo: templatesPageNo.value,
      pageSize: TEMPLATE_PAGE_SIZE
    }
    const res = await TemplateApi.getPPTPageList({ params })

    if (res.code === 'SUCCESS' && res.data) {
      const list = (res.data.list || []).map(normalizeTemplateItem)
      if (reset) {
        templates.value = list
      } else {
        templates.value = [...templates.value, ...list]
      }
      templatesTotal.value = res.data.total || 0
    } else if (reset) {
      templates.value = []
      templatesTotal.value = 0
    }
  } catch (error) {
    console.error('获取模板列表失败:', error)
    if (!reset) {
      templatesPageNo.value = Math.max(1, templatesPageNo.value - 1)
    } else {
      templates.value = []
      templatesTotal.value = 0
    }
  } finally {
    if (reset) {
      templatesLoading.value = false
    }
    templatesLoadingMore.value = false
  }
}


const handleCreate = () => {
  reportEvent('app_clicks', {
    ck_module: '首页_立即生成',
  })
  if (!canSubmit.value) {
    ElMessage.error({
      message: '请输入要生成PPT的主题或上传参考文档',
      offset: 60,
    })
    return
  }

  // 上传中或失败时阻止提交
  if (localFileInfo.value && localFileInfo.value.status === 'uploading') {
    ElMessage.error({
      message: '文件正在上传中，请稍后',
      offset: 60,
    })
    return
  }
  if (localFileInfo.value && localFileInfo.value.status === 'error') {
    ElMessage.error({
      message: '文件上传失败，请重新上传',
      offset: 60,
    })
    return
  }

  if (!ensureNativeLogin()) return

  if (isMiniAppWebview()) {
    // 新开独立 web-view 会丢 Pinia 内存态：localStorage + cookie + URL(base64) 三通道带草稿
    persistOutlineDraftIfPossible()
    const draft = {
      inputText: outlineParams.value.inputText || '',
      pageCount: outlineParams.value.pageCount || defaultOutlineOptions.pageCount,
      language: outlineParams.value.language || defaultOutlineOptions.language,
      audiences: outlineParams.value.audiences || defaultOutlineOptions.audiences,
      textVolume: outlineParams.value.textVolume || defaultOutlineOptions.textVolume,
      scene: outlineParams.value.scene || defaultOutlineOptions.scene,
      fujian: outlineParams.value.fujian || uploadedFile.value?.fujian || '',
      fileName: localFileInfo.value?.name || uploadedFile.value?.name || '',
    }
    saveOutlineDraftToStorage(draft)
    writeOutlineDraftToCookie(draft)

    let h5Draft = ''
    try {
      const encoded = encodeOutlineDraftForTransport(draft)
      // base64 通常比 raw JSON 更短且无特殊字符，优先塞进小程序 URL
      if (encoded.length <= 1200) h5Draft = encoded
    } catch {
      /* ignore */
    }

    requestMiniAppOpenWebview({
      path: '/m/create',
      title: '生成大纲',
      fullscreen: true,
      fromTab: 'home',
      h5Draft: h5Draft || undefined,
    })
    return
  }

  router.push('/m/create')
}

const getUser = async (data) => {
  const { getUserInfo } = await import('@/api/user.ts')
  getUserInfo(data).then(res => {
    if (res.code === 'SUCCESS') {
      userStore.setUserInfo(res.data)
    }
  })
}

// 监听 uploadedFile 变化，同步本地状态（例如从其他页面返回）
watch(uploadedFile, (newFile) => {
  if (newFile && newFile.name) {
    if (!localFileInfo.value || localFileInfo.value.name !== newFile.name) {
      localFileInfo.value = {
        name: newFile.name,
        status: 'success'
      }
    }
  } else if (!newFile) {
    localFileInfo.value = null
  }
}, { immediate: true, deep: true })


window.getHome = function(){
  getHomeBannerList()
}

onMounted(() => {
  syncTabBarHeightIfNeeded(tabBarHeight.value, (h) => appStore.setTabBarHeight(h))
  setupCustomGesture()
  fetchUnreadCount()
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      getUser()
    }, { timeout: 1500 })
  } else {
    setTimeout(() => {
      getUser()
    }, 500)
  }
  fetchTemplates(true)
  showAndiroTab(true)
  reportEvent('page_view', {
    page_name: '首页',
  });
  init()
  window.addEventListener(NOTIFICATION_UNREAD_REFRESH_EVENT, fetchUnreadCount)
})

onActivated(setupCustomGesture)
onDeactivated(teardownCustomGesture)

onBeforeUnmount(() => {
  clearHotMarqueeTimer()
  teardownCustomGesture()
  window.removeEventListener(NOTIFICATION_UNREAD_REFRESH_EVENT, fetchUnreadCount)
})
</script>

<style lang="scss" scoped>
.home-mobile {
  background-size: 100% auto;
  background-image: url('@/assets/images/mobile/mobile_home_bg.png');
  background-repeat: no-repeat;
}

.yidian-home-content {
  // box-shadow: 0px 13px 19px 0px rgba(102, 145, 254, 0.14);
}

.miniapp-ai-disclaimer {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  line-height: 1.4;
  color: #9aa0a6;
  font-weight: 400;
}

.yidian-mobile-btn {
  background: linear-gradient( 90deg, #5787FF 0%, #1858F7 100%);

  &.btn-disabled {
    // background: #cccccc;
    opacity: 0.4;
    cursor: not-allowed !important;
  }

  &.btn-enabled {
    &:active {
      transform: scale(0.98);
      transition: transform 0.1s ease;
    }
  }
}

.mobile-input-options-row {
  margin-bottom: 16px;
}

.mobile-input-options-scroll-wrap {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 36px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255,0.8) 100%);
    pointer-events: none;
    z-index: 1;
  }
}

.mobile-input-options-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.input-options-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  min-width: 100%;
}

.option-select-trigger {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  min-height: 33px;
  padding: 0 12px;
  background: rgba(6,10,38,0.03);
  border: 1px solid rgba(6,10,38,0.03);
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;

  .option-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .option-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 500;
  }

  .option-label-name {
    color: rgba(6, 10, 38, 0.6);
  }

  .option-label-value {
    color: #060a26;
  }

  .option-arrow {
    font-size: 14px;
    color: #94A3B8;
  }
}

.option-edit-btn {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: #666772;
  cursor: pointer;
  background: transparent;
  // border: 1px solid #f0f4ff;
  border-radius: 12px;
}

.mobile-hot-topics {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-hot-topics-row {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.hot-topics-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  animation: hot-topics-marquee linear infinite;
  will-change: transform;

  &.is-marquee-paused {
    animation-play-state: paused;
  }

  &.is-marquee-manual {
    animation: none;
    transform: none;
  }
}

@keyframes hot-topics-marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.hot-topic-item {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  max-width: 200px;
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 1;
  color: rgba(6,10,38,0.6);
  border: 1px solid rgba(6,10,38,0.06);
  white-space: nowrap;
  cursor: pointer;
  border-radius: 46px;
}

.main-input-wrapper {
  position: relative;
  margin-bottom: 14px;

  .gradient-border {
    position: relative;
    border-radius: 16px;
    padding: 1px;
    /* 这里的 2px 即为边框宽度 */
    /* 直接把渐变加在这里，去掉 ::before */
    background: linear-gradient(97deg, rgba(85, 139, 255, 1), rgba(152, 229, 255, 1));
    box-shadow: 0px 6px 9px 0px rgba(117,128,255,0.12);
  }

  .input-content {
    position: relative;
    background-color: white;
    /* 遮住中间的渐变，只漏出 padding 区域 */
    /* 关键点：内部圆角 = 外部圆角 - padding宽度 */
    /* 30px - 2px = 28px，这样看起来圆角才同心，不会粗细不均 */
    border-radius: 15px;
    padding: 12px;
    height: 100%;
    /* 确保填满高度 */
  }

  .main-input {
    width: 100%;
    min-height: 60px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    resize: none;
    color: #333;

    &:focus {
      outline: none;
      background-color: white;
    }

    &::placeholder {
      color: #999;
    }
  }

  .shiny-placeholder {
    position: absolute;
    top: 12px;
    left: 12px;
    right: 12px;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    text-align: left;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: transparent;
    background-image: linear-gradient(
      90deg,
      rgba(129, 140, 155, 0.86) 0%,
      rgba(129, 140, 155, 0.86) 42%,
      rgba(6, 10, 38, 0.92) 50%,
      rgba(129, 140, 155, 0.86) 58%,
      rgba(129, 140, 155, 0.86) 100%
    );
    background-size: 150% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    animation: shiny-text-flow 3.3s linear infinite;
    z-index: 2;
  }

  .input-actions {
    display: flex;
    justify-content: space-between;
    align-items: end;
    // margin-top: 12px;
    gap: 12px;

    .input-char-count {
      margin-left: auto;
      flex-shrink: 0;
      font-size: 11px;
      line-height: 1;
      color: rgba(6, 10, 38, 0.35);
      pointer-events: none;
      white-space: nowrap;
    }

    /* 文件信息条样式 */
    .file-info-box {
      // flex: 1;
      // height: 72px;
      padding: 8px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid rgba(9, 24, 54, 0.07);

      .file-info-content {
        display: flex;
        align-items: center;
        width: 100%;


        .file-icon {
          flex-shrink: 0;
        }


        .file-status {
          .is-loading {
            animation: rotating 1.5s linear infinite;
          }
        }
      }
    }

    .upload-btn {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 30px;
      padding: 6px 8px 6px 6px;
      border: 1px solid rgba(6,10,38,0.06);
      border-radius: 8px;
      background-color: white;
      color: #1D1F26;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s ease;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.option-drawer-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 16px 20px;
  box-sizing: border-box;
}

.option-drawer-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
  flex-shrink: 0;

  &::-webkit-scrollbar {
    display: none;
  }
}

.option-drawer-tab {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 56px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #060a26;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 23px;
  white-space: nowrap;
  transition: all 0.2s ease;

  &.is-active {
    color: #1858f7;
    background: rgba(50, 108, 255, 0.04);
  }
}

.option-drawer-tab-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.option-drawer-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.option-grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  color: #060a26;
  text-align: center;
  cursor: pointer;
  background: rgba(6, 10, 38, 0.03);
  border: none;
  border-radius: 40px;
  transition: all 0.2s ease;

  &.is-selected {
    color: #1858f7;
    background: rgba(50, 108, 255, 0.06);
  }

  &--custom {
    grid-column: span 1;
    gap: 6px;
    justify-content: center;
  }
}

.option-grid-custom-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.option-drawer-footer {
  display: flex;
  flex-shrink: 0;
  gap: 12px;
  margin-top: 16px;
}

.option-drawer-btn {
  flex: 1;
  height: 44px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  border-radius: 22px;
  transition: opacity 0.2s ease;

  &:active {
    opacity: 0.85;
  }

  &--ghost {
    color: #060a26;
    background: #fff;
    border: 1px solid rgba(6, 10, 38, 0.12);
  }

  &--primary {
    color: #fff;
    background: linear-gradient(90deg, #5787ff 0%, #1858f7 100%);
  }
}

.custom-scene-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  background: rgba(0, 0, 0, 0.45);
}

.custom-scene-modal {
  width: 100%;
  max-width: 320px;
  padding: 20px 16px 16px;
  background: #fff;
  border-radius: 16px;
}

.custom-scene-title {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: #060a26;
  text-align: center;
}

.custom-scene-input-wrap {
  position: relative;
  margin-bottom: 20px;
}

.custom-scene-input {
  width: 100%;
  height: 44px;
  padding: 0 52px 0 14px;
  font-size: 14px;
  color: #060a26;
  background: #f5f6f8;
  border: none;
  border-radius: 12px;
  outline: none;

  &::placeholder {
    color: rgba(6, 10, 38, 0.35);
  }
}

.custom-scene-count {
  position: absolute;
  top: 50%;
  right: 12px;
  font-size: 12px;
  color: rgba(6, 10, 38, 0.35);
  transform: translateY(-50%);
}

.custom-scene-actions {
  display: flex;
  gap: 12px;
}

.custom-scene-btn {
  flex: 1;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  border-radius: 20px;

  &--ghost {
    color: #060a26;
    background: #fff;
    border: 1px solid rgba(6, 10, 38, 0.12);
  }

  &--primary {
    color: #fff;
    background: linear-gradient(90deg, #5787ff 0%, #1858f7 100%);
  }
}

:deep(.mobile-option-drawer .el-drawer) {
  border-radius: 20px 20px 0 0;
}

:deep(.mobile-option-drawer .el-drawer__body) {
  height: 100%;
  padding: 0;
}

.member-banner {
  :deep(.member-banner-image) {
    width: 100%;
    display: block;
    border-radius: 12px;
    overflow: hidden;
  }
}

.swiper-member {
  border-radius: 12px;
  overflow: hidden;

  :deep(.swiper-slide) {
    cursor: pointer;
  }
}

/* 隐藏滚动条 */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

@keyframes shiny-text-flow {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -20% 0;
  }
}
</style>
